// extracted by mini-css-extract-plugin
module.exports = {"dashboardWrapper":"dashboardWrapper--+35m4","title":"title--yht9W"};